import api from './api';

export interface Gravacao {
  id: number;
  datahorainicio?: string;
  datahorafim?: string;
  amazonpath?: string;
  dataremocao?: string;
  emissora_id?: number;
  anuncio_id?: number;
  duracao?: number;
  emissora?: { id: number; nome: string };
  anuncio?: { id: number; nome: string };
}

export interface GravacaoCreate {
  datahorainicio?: string;
  datahorafim?: string;
  amazonpath?: string;
  emissora_id?: number;
  anuncio_id?: number;
  duracao?: number;
}

export interface GravacaoUpdate {
  datahorainicio?: string;
  datahorafim?: string;
  amazonpath?: string;
  emissora_id?: number;
  anuncio_id?: number;
  duracao?: number;
}

export interface GravacaoFilter {
  emissora_id?: number;
  anuncio_id?: number;
  data_inicio?: string;
  data_fim?: string;
}

export const GravacoesService = {
  getGravacoes: async (filter: GravacaoFilter = {}, skip = 0, limit = 100) => {
    const { emissora_id, anuncio_id, data_inicio, data_fim } = filter;
    const params = { skip, limit, emissora_id, anuncio_id, data_inicio, data_fim };
    const response = await api.get('/gravacoes', { params });
    return response.data;
  },

  getGravacao: async (id: number) => {
    const response = await api.get(`/gravacoes/${id}`);
    return response.data;
  },

  createGravacao: async (gravacao: GravacaoCreate) => {
    const response = await api.post('/gravacoes', gravacao);
    return response.data;
  },

  updateGravacao: async (id: number, gravacao: GravacaoUpdate) => {
    const response = await api.put(`/gravacoes/${id}`, gravacao);
    return response.data;
  },

  deleteGravacao: async (id: number) => {
    const response = await api.delete(`/gravacoes/${id}`);
    return response.data;
  }
}; 